export const CHAT_NAVIGATION_EVENT = 'eightbots-chat-action';
export type ChatNavigationAction = 'chats' | 'new-chat' | 'conversation' | 'terminal' | 'whatsapp';
export function requestChatAction(action: ChatNavigationAction): void {
  window.dispatchEvent(new CustomEvent(CHAT_NAVIGATION_EVENT, {detail: action}));
}
